<script lang="ts">
  // The connect button on a Sync page: the service's mark and name on its brand colour. A link with
  // `href`, otherwise a button that dispatches click.
  import { Button } from '$lib/components/ui/button'
  import { SERVICES, type SyncService } from './services'

  export let service: SyncService
  export let label = `Connect with ${SERVICES[service].name.replace(' Connect', '')}`
  export let href: string | undefined = undefined
  export let disabled = false

  $: info = SERVICES[service]
</script>

<Button size="lg" class="h-11 gap-2.5 px-5 text-base font-semibold text-white hover:brightness-110 disabled:opacity-60"
  style="background-color: {disabled ? 'hsl(var(--muted-foreground))' : info.color}" href={disabled ? undefined : href} {disabled} on:click>
  {#if info.icon}
    <i class="{info.icon} text-lg" aria-hidden="true" />
  {:else if info.mask}
    <span class="block h-5 w-5 bg-white" style="-webkit-mask: url('{info.mask}') center / contain no-repeat; mask: url('{info.mask}') center / contain no-repeat;" aria-hidden="true" />
  {/if}
  {label}
</Button>
